import { DateTime } from "luxon";
import React, { ChangeEvent } from "react";
import { V2 } from "../../Api";
import { formatDateLocalNumeric, formatName } from "../../Utilities";

import withTitle from "../withTitle";

interface IMetricsWcasReportViewState {
    isLoading: boolean | string;
    results: any[];

    after: string;
    before: string;
}

class MetricsWcasReportView extends React.Component<{}, IMetricsWcasReportViewState> {
    constructor(props: Readonly<{}>) {
        super(props);

        const state: IMetricsWcasReportViewState = {
            isLoading: true,
            results: [],

            after: DateTime.local().startOf("month").toISODate(),
            before: DateTime.local().endOf("month").plus({ days: 1 }).toISODate(),
        };

        this.state = state;

        this.loadData = this.loadData.bind(this);
        this.formInputChanged = this.formInputChanged.bind(this);
    }

    public componentDidMount() {
        this.loadData();
    }

    public render() {
        return (
            <div className="viewer-root">
                <div className="filter-control-box">
                    <div className="control-group">
                        <span>Start Date:</span>
                        <input type="date" name="after" value={this.state.after} onChange={this.formInputChanged} />
                    </div>
                    <div className="control-group">
                        <span>End Date:</span>
                        <input type="date" name="before" value={this.state.before} onChange={this.formInputChanged} />
                    </div>
                    <button type="button" className="button" onClick={this.loadData}>Run Report</button>
                </div>


                {this.state.isLoading === true
                    ? <div className="spinner lds-dual-ring-big" />
                    : typeof this.state.isLoading === "string"
                        ? <div className="error-text">{this.state.isLoading}</div>
                        : <table className="table-vertical">
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Name</th>
                                    <th>Birthdate</th>
                                    <th>Chart #</th>
                                    <th>Email address</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.results.map(a => <tr key={a.chartNumber + a.date}>
                                    <td>{formatDateLocalNumeric(a.date)}</td>
                                    <td>{formatName(a.name)}</td>
                                    <td>{formatDateLocalNumeric(a.birthdate)}</td>
                                    <td>{a.chartNumber}</td>
                                    <td>{a.emailAddress}</td>
                                </tr>)}
                            </tbody>
                        </table>}
            </div>
        );
    }

    private async loadData() {
        try {
            const parameters = [
                `after=${encodeURIComponent(this.state.after)}`,
                `before=${encodeURIComponent(this.state.before)}`
            ];

            const result = await V2.get<any>(`metrics/ad-hoc/wcas-emails?${parameters.join("&")}`);

            this.setState({
                isLoading: false,
                results: result.results || []
            });
        }
        catch (e) {
            this.setState({
                isLoading: e.message || "Could not load report"
            });
        }
    }

    private formInputChanged(e: ChangeEvent<HTMLInputElement>) {
        const name = e.currentTarget.name;
        const value = e.currentTarget.value;

        this.setState({
            [name]: value
        } as any);
    }
}

export default withTitle("WCAS Survey Report", MetricsWcasReportView);
